import {Box, Button, Typography} from '@viptech/react-components'
import {useState} from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {Input} from '../../../../../../../../components/input/Input'
import {ChosenObject} from '../../StepperModal'
import Card from '../../common/components/Card'
import {ContainerColumn} from './ConfigStepBase'

type Props = {
  chosen: ChosenObject | null
  permanenceThresholdValue: number
  setChosen: (choices: Partial<ChosenObject>) => void
}

const PermanenceThreshold = (props: Props) => {
  const {chosen, permanenceThresholdValue, setChosen} = props
  const {styledTheme} = usePersonalizedThemeByCompany()
  const thresholds = [
    {id: 10, label: '10s'},
    {id: 60, label: '1min'},
    {id: 120, label: '2min'},
    {id: 300, label: '5min'},
    {id: 600, label: '10min'},
  ]

  const [showThresholdInput, setShowThresholdInput] = useState(!!!thresholds.find((it) => it.id === permanenceThresholdValue))

  const TitleAndLabelComponent = ({title, label}: {title: string; label: string}) => {
    return (
      <Box>
        <Typography variant='span' size='16px' style={{fontWeight: 500}}>
          {title}
        </Typography>
        <Typography variant='p' size='12px' color='#8E8E8E'>
          {label}
        </Typography>
      </Box>
    )
  }

  if (!chosen?.detectionTypeChosen?.includes('Tempo de Permanência')) return <></>

  return (
    <Box align='center' justifyContent='center'>
      <TitleAndLabelComponent title={'Limite de Tempo de Permanência'} label={'Especifique o tempo máximo permitido, em segundos.'} />

      <Box display='flex' columnGap='10px' align='center'>
        <ContainerColumn>
          {thresholds.map((it) => {
            return (
              <Card
                dispatchTo={it.label}
                selected={permanenceThresholdValue === it.id}
                initialState={!permanenceThresholdValue}
                onClick={() => setChosen({maximumTime: it.id})}
                key={it.id}
              />
            )
          })}
        </ContainerColumn>
        {!showThresholdInput ? (
          <Button
            fontSize='12px'
            height='40px'
            width='150px'
            variant='outlined'
            color={styledTheme.colors.primary}
            marginTop='18px'
            onClick={() => setShowThresholdInput(true)}>
            Personalizar
          </Button>
        ) : (
          <Input.Root
            height='40px'
            width='150px'
            labelFontSize='12px'
            fontSize='12px'
            marginTop='18px'
            controlled
            value={String(permanenceThresholdValue)}
            rightIcon={<p style={{fontSize: '12px'}}>s</p>}
            onChange={(e) => setChosen({maximumTime: Number(e.target.value)})}
            borderColor={styledTheme.colors.primary}
          />
        )}
      </Box>
    </Box>
  )
}

export default PermanenceThreshold
